var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user_info"},[_c('div',{staticClass:"top_bg"},[_c('div',{staticClass:"top_main"},[_c('div',{staticClass:"top_main_title"},[_vm._v("电影放映协会")]),_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }